var _path, _g, _rect, _circle, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRemove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 94,
    viewBox: "0 0 74 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.354 86V77.306C15.354 76.704 15.69 76.494 16.124 76.396C16.404 76.34 17.118 76.256 18.574 76.256C21.5 76.256 22.956 77.46 22.956 79.378C22.956 80.722 22.27 81.576 21.15 82.066C21.934 83.144 22.788 84.782 23.418 86H21.486C21.192 85.37 20.016 83.172 19.498 82.458C19.176 82.5 18.812 82.514 18.518 82.514C17.86 82.514 17.216 82.458 16.978 82.416V86H15.354ZM16.978 77.754V80.988C17.216 81.03 17.664 81.1 18.574 81.1C20.59 81.1 21.248 80.4 21.248 79.392C21.248 78.468 20.66 77.67 18.532 77.67C17.594 77.67 17.132 77.712 16.978 77.754ZM29.9468 84.362L30.5348 85.482C30.2268 85.678 29.2468 86.196 27.7348 86.196C25.6628 86.196 23.9828 84.894 23.9828 82.542C23.9828 80.302 25.6068 78.776 27.7908 78.776C29.7368 78.776 30.8008 79.84 30.8008 81.1C30.8008 82.388 29.9468 83.284 26.7408 83.284C26.3628 83.284 26.0688 83.27 25.6908 83.256C25.8448 84.208 26.6008 84.852 28.0428 84.852C29.0088 84.852 29.7088 84.488 29.9468 84.362ZM25.6208 82.164C26.0548 82.178 26.4328 82.178 26.8248 82.178C28.8968 82.178 29.2468 81.618 29.2468 81.072C29.2468 80.358 28.6028 80.008 27.7628 80.008C26.3908 80.008 25.6628 81.072 25.6208 82.164ZM32.0298 83.886V77.726C32.0298 77.208 32.3518 76.984 32.8698 76.984C33.2058 76.984 33.5278 77.096 33.6258 77.138V78.972H35.6558C36.2718 78.972 36.4958 79.224 36.4958 79.714C36.4958 80.036 36.3698 80.33 36.3138 80.442H33.6258V83.564C33.6258 84.516 34.1998 84.782 34.8858 84.782C35.4318 84.782 35.9358 84.572 36.1458 84.418L36.7898 85.482C36.4818 85.706 35.6838 86.196 34.5218 86.196C32.8838 86.196 32.0298 85.272 32.0298 83.886ZM37.6906 86V79.714C37.6906 79.196 37.9986 78.972 38.5446 78.972C38.8806 78.972 39.1886 79.084 39.2866 79.126V86H37.6906ZM38.4886 75.822C39.0346 75.822 39.4546 76.242 39.4546 76.788C39.4546 77.334 39.0346 77.754 38.4886 77.754C37.9426 77.754 37.5226 77.334 37.5226 76.788C37.5226 76.242 37.9426 75.822 38.4886 75.822ZM40.9975 86V81.478C40.9975 79.756 42.1175 78.776 43.9795 78.776C45.1555 78.776 45.9675 79.098 45.9675 79.77C45.9675 80.092 45.7295 80.442 45.6175 80.512C45.2955 80.358 44.8335 80.204 44.2315 80.204C43.1395 80.204 42.5935 80.778 42.5935 81.94V86H40.9975ZM53.013 81.758V85.972C52.635 86.042 51.361 86.196 49.905 86.196C46.993 86.196 46.335 85.104 46.335 83.928C46.335 82.402 47.217 81.604 49.695 81.604C50.409 81.604 51.095 81.66 51.417 81.702C51.417 80.386 50.535 80.064 49.275 80.064C48.211 80.064 47.567 80.386 47.357 80.554C47.245 80.456 46.979 80.19 46.979 79.812C46.979 79.28 47.469 78.776 49.303 78.776C51.487 78.776 53.013 79.574 53.013 81.758ZM51.431 84.908V82.864C51.249 82.822 50.773 82.724 49.751 82.724C48.477 82.724 47.931 83.088 47.931 83.914C47.931 84.6 48.365 85.034 49.905 85.034C50.759 85.034 51.263 84.95 51.431 84.908ZM54.6558 86V81.478C54.6558 79.756 55.7758 78.776 57.6378 78.776C58.8138 78.776 59.6258 79.098 59.6258 79.77C59.6258 80.092 59.3878 80.442 59.2758 80.512C58.9538 80.358 58.4918 80.204 57.8898 80.204C56.7978 80.204 56.2518 80.778 56.2518 81.94V86H54.6558Z",
    fill: "#FF2D55"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_10870_270)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 36,
    r: 28,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.875 38.1875C33.875 39.4 34.8125 40.375 35.9625 40.375H38.3125C39.3125 40.375 40.125 39.525 40.125 38.4625C40.125 37.325 39.625 36.9125 38.8875 36.65L35.125 35.3375C34.3875 35.075 33.8875 34.675 33.8875 33.525C33.8875 32.475 34.7 31.6125 35.7 31.6125H38.05C39.2 31.6125 40.1375 32.5875 40.1375 33.8",
    stroke: "#FF2D55",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37 30.375V41.625",
    stroke: "#FF2D55",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5 36C24.5 29.1 30.1 23.5 37 23.5C43.9 23.5 49.5 29.1 49.5 36C49.5 42.9 43.9 48.5 37 48.5",
    stroke: "#FF2D55",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 45,
    width: 7,
    height: 1,
    rx: 0.5,
    fill: "#FF2D55"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 45.5,
    r: 5,
    stroke: "#FF2D55"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_10870_270",
    x: 0,
    y: 0,
    width: 74,
    height: 74,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10870_270"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10870_270",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRemove);
export default __webpack_public_path__ + "static/media/icon-remove.a69401b026f6619a9811d4ad6e6e36d5.svg";
export { ForwardRef as ReactComponent };